// 所有接口地址汇总，清晰管理
import baseUrl from "./baseUrl";

const apis = {
  'report': '/v1/h5/report',                         // 打点接口
  'report_unsafe': '/stat/unsafe',                    // unsafe打点
  'booksharereport': '/v1/activity/booksharereport',     // H5微信分享打点
  'activityIsJoin': '/activity/isjoin',                    // unsafe打点
  'activityClick': '/activity/click',                    // unsafe打点
  // 福利中心
  'welfare_index': '/v1/benefith5/index',            // 任务中心主接口
  'welfare_books': '/v1/benefith5/recommendBooks',   // 任务中心推荐书籍
  'getCoupon': '/v1/Benefith5/getCoupon',             // 领礼券
  'doLottery': '/v1/benefith5/doLottery',            // 抽奖
  'h5Pay': '/chargeh5/index',                         // H5支付
  'h5PayCheck': '/chargeh5/check',                     // H5支付结果检测
  // 官网充值
  'h5payWay': '/chargenewh5/way',                     // 官网充值配置项，可传用户标识
  'h5payIndex': '/chargenewh5/index',                     // 官网充值配置项，可传用户标识
  'h5payCheck': '/chargenewh5/check',                     // 官网充值配置项，可传用户标识
  // 在客户端中使用H5支付
  'chargeh5Pay': '/chargeh5/index',
  'chargeh5PayCheck': '/chargeh5/check',
  // wifi push 收藏书籍
  'chkBookV3': '/v1/activity/chkBookV3',              // 检查书籍是否加书架
  'addBookshelfV3': '/v1/activity/addBookshelfV3',      // 加书架
  // 充送活动
  'chargeAcList': '/v1/myh5/chargeAcList',              // 充送活动
  'vipMy': '/v1/viph5/my',              // 充送活动
  // 章节推荐
  'chapterRecBooks': '/v1/benefith5/chapterRecBooks',              // 充送活动
  // 新年钥匙老用户拉活
  'getPullLiveCoupon': '/v1/activity/getPullLiveCoupon',
  // 豪华签到
  'punchCard_index': '/v1/h5sign/index',         // 初始化接口
  'punchCard_register': '/v1/h5sign/register',      // 免费报名
  'punchCard_rank': '/v1/h5sign/rank',      // 免费报名
  'punchCard_sign': '/v1/h5sign/sign',      // 打卡
  'punchCard_expose': '/v1/h5sign/expose',      // 标记用户打卡超时以及发放奖励弹窗是否显示
  // webqq
  'webqq': '/kefu/h5',
  // 网赚，师徒系统
  'h5EarnCode':'/v1/h5earns/code',
  'h5EarnFirends':'/v1/h5earns/firends',
  'h5RemindFriend':'/v1/h5earns/remindfriend',
  // 0元畅读
  'h5cardGetInfo': '/v1/h5card/getCardInfo',
  'h5discountcheck': '/v1/h5charge/discountcheck',
  // 分享微信
  'bookInfoshare': '/v1/activity/bookshare',
  // 用户喜好标签
  'popupGetCate': '/v1/H5popup/getCateList',
  'popupSyncPrefer': '/v1/H5popup/syncPrefer',
  'popupGetBooks': '/v1/H5popup/getBooks',
  'popupGetPrefer': '/v1/H5popup/getPrefer',
  // 7日无点击召回
  'H5pushbooklist': '/v1/H5push/booklist',
  'H5pushAddBookshelf': '/v1/H5push/addBookshelf',  // post
  'H5CheckBookshelf': '/v1/H5push/checkBookshelf',  // post
  // 双十一活动
  'h5ActIsJoin': '/v1/h5active/isJoin',
  'h5ActgainCoupon': '/h5active/gainCoupon',
  // 兑换Vip
  'H5activeDuihuan': '/v1/H5active/duihuan',
  // 领卡活动
  'h5activeInit': '/h5active/initconfig',
  //手机抽奖活动
  'h5DrawInit':'/v1/h5draw/index',
  'drawAwardList':'/v1/h5draw/awardList',
  'drawSaveAward':'/v1/h5draw/saveAward',
  'drawShare':'/v1/h5draw/share',
  // 长简介
  'getLongDescription': '/v1/H5dialog/getLongDescription',
  'getBookmallDescription': '/v1/h5dialog/getBookmallDescription',
  // 新用户挽留抽奖
  'H5lotteryConf': '/v1/H5lottery/conf',
  'H5lotteryDraw': '/v1/H5lottery/draw',
  'H5lotteryConfLxsdk': '/v1/H5lottery/confsdk',
  'H5lotteryDrawLxSdk': '/v1/H5lottery/drawsdk',
  // 新福利中心
  'H5missionStatus': '/v1/H5mission/status',
  'setCalendarReminder': '/v1/H5mission/setCalendarReminder',
  'H5missionExchange': '/v1/H5mission/exchange',
  'getGlodTaskAward': '/v1/H5mission/getTaskAward',
  // 查看碎片
  'h5drawPhone': '/v1/h5draw/phone',
  // CP书下架引导充值
  'cpPayFeedBack': '/v1/h5active/payFeedBack',
  'cpRecomBookList': '/v1/h5active/book',
  // 抽手机碎片v3版本
  'h5lotterynewConf': '/v1/h5lotterynew/conf',
  'h5lotterynewPrizelist': '/v1/h5lotterynew/prizelist',
  'h5lotterynewDrawtask': '/v1/h5lotterynew/drawtask',
  'h5lotterynewDraw': '/v1/h5lotterynew/draw',
  // 提交手机领取VIP年卡
  'H5activeQinghua': '/v1/H5active/qinghua',
  // pushStore push推送高质量高留存书H5列表
  'h5recommend': '/v1/H5mission/recommend',
  'h5recommendmore': '/v1/H5mission/recommendmore',
  'h5getTaskAward': '/v1/H5mission/getTaskAward',
  // 领取VIP
  'h5receiveVIP': '/v1/viph5/genrevad',
  'h5receiveVIPInfo': '/v1/viph5/initconfig', // 获取领取基本信息
  'getVIPForNJ': '/v1/H5active/sxvip', // 获取领取基本信息

  'showNewList': '/v1/h5wifisdk/recommend', // 美女推书列表
  'showNewList_t': '/v1/h5wifisdk/recommendv2', // 美女推书列表
  // 钥匙VIP
  'ysVIPInfo': '/v1/h5wifievent/conf', // 基本信息
  'ysGetReward': '/v1/h5wifievent/draw', // 获取奖励

  // 激励信息流提现
  'withdrawalInfo': '/v1/H5feeds/info', // 激励信息流基本数据
  'withdrawalSub': '/v1/H5feeds/withdrawl', // 激励信息流提交申请

  // 年末小说排行榜
  'allYearInfo': '/v1/h5yearendrank/index', // 年末小说基本数据
  'allYearAddBook': '/v1/h5yearendrank/batchAddBookshelf', // 年末小说一键加入书架

  // SDK导量
  'sdkCount': '/v1/h5wifimigrate/wifisdkclick', // 导量

  // 听书
  'videoList': '/v1/h5wifiaudio/index',
  'videoNewList': '/v1/h5wifiaudio/indexv2',
  'videoNewMoreList': '/v1/h5wifiaudio/guesslike',

  // 0元免广告
  'freeVideoList': '/v1/h5freead/index',
  'freeVideoTime': '/v1/h5freead/validity',

  // 阅读3章
  'recommendList': '/v1/h5readpromote/index',

  // 发现tab
  'findTabList': '/v1/h5feedbook/index',

  // 原创
  'soleList': '/v1/h5wifizxsj/index',

  // 新书城
  'newBookList': '/v1/h5bookmall/module',

  // 付费榜单
  'payRankList': '/v1/h5wifipaybook',

  // 重构福利页
  'newWelfareInfo': '/v1/h5welfare',
  'coinDetailList': '/v1/h5welfare/record',
  'coinInfo': '/v1/h5welfare/account',
  'getCoin': '/v1/h5welfare/draw',

  // 新人7天福利
  "getWelfareData": '/v1/h5welfarenewuser', // 新人7天福利基础数据
  "getSignData": '/v1/h5welfarenewuser/draw', // 签到
  "getRollData": '/v1/h5welfarenewuser/roll', // 滚动数据
  "getBookList": '/v1/h5welfarenewuser/books',
  "getTaskInfo": '/v1/h5welfarenewuser/task', // 获取任务数据
  "getIsShowPop": '', // 7天签到活动获取是否需要弹窗
  "getNewGoldBalance": '/v1/h5welfare/account', // 获取金币余额


  // 福利中心改版
  "getCenterBalance": '/v1/h5welfare/account', // 获取金币余额
  "getCenterRollData": '/v1/h5welfareuser/roll', // 滚动数据
  "getCenterBookList": '/v1/h5welfareuser/books', // 书籍数据
  "getCenterData": '/v1/h5welfareuser', // 基础数据
  "getCenterDaySign": '/v1/h5welfareuser/sign', // 基础数据
  "getCenterSignData": '/v1/h5welfareuser/draw',
  "getCenterTaskInfo": '/v1/h5welfareuser/task', // 获取任务数据
  "getCenterIsShowPop": '', // 7天签到活动获取是否需要弹窗

}

let API = {}
for (const key in apis) {
  if (apis.hasOwnProperty(key)) {
    const element = apis[key];
    API[key] = baseUrl + element
  }
}

export default API



// WEBPACK FOOTER //
// ./src/api/API.js